import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationRoutingModule } from './registration-routing.module';
import { RegistrationComponent } from './registration.component';
import { RegistrationDetailsComponent } from './registration-details/registration-details.component';
import {
  MatTabsModule,
  MatCardModule,
  MatCheckboxModule,
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatInputModule,
  MatNativeDateModule,
  MatSelectModule,
  MatIconModule,
  MatRadioModule
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxStripeModule } from 'ngx-stripe';
import { BankInfoComponent } from './bank-info/bank-info.component';
import { TCPAndInsuranceComponent } from './tcp-and-insurance/tcp-and-insurance.component';
import { VerificationComponent } from './verification/verification.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { RegistrationStepperComponent } from './components/registration-stepper/registration-stepper.component';
import { RegVehiclesComponent } from './vehicles/reg-vehicles.component';
import { RegDriverProfileComponent } from './drivers/reg-driver-profile.component';
import { RegDriverAssignVehicleComponent } from './drivers/reg-driver-assign-vehicle.component';
import { RegDriverVerificationComponent } from './drivers/reg-driver-verification.component';
import { RegDriverBankComponent } from './drivers/reg-driver-bank.component';
import { RegDriverPreviewComponent } from './drivers/reg-driver-preview.component';
import { RegDriverPayoutSetupComponent } from './drivers/reg-driver-payout-setup.component';
import { RegDriverPayoutReturnComponent } from './drivers/reg-driver-payout-return.component';
import { PayoutSetupComponent } from './payout-setup/payout-setup.component';
import { PayoutReturnComponent } from './payout-return/payout-return.component';

@NgModule({
  imports: [
    CommonModule,
    RegistrationRoutingModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    NgxStripeModule.forRoot(),
    MatTabsModule,
    MatCardModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    GooglePlaceModule,
    MatSelectModule,
    MatIconModule,
    MatRadioModule
  ],
  declarations: [
    RegistrationComponent,
    RegistrationDetailsComponent,
    BankInfoComponent,
    TCPAndInsuranceComponent,
    VerificationComponent,
    RegistrationStepperComponent,
    RegVehiclesComponent,
    RegDriverProfileComponent,
    RegDriverAssignVehicleComponent,
    RegDriverVerificationComponent,
    RegDriverBankComponent,
    RegDriverPreviewComponent,
    RegDriverPayoutSetupComponent,
    RegDriverPayoutReturnComponent,
    PayoutSetupComponent,
    PayoutReturnComponent
  ]
})
export class RegistrationModule {}
